import type { IconSvgObject } from './types';

const Astronaut01Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "11", r: "3", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.6573 18C19.6963 16.35 21 13.8273 21 11C21 6.02944 16.9706 2 12 2C7.02944 2 3 6.02944 3 11V20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.5037 17.5L14 13M18.0037 5L14 9", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17 18H3V22H21C21 21.07 21 20.605 20.8978 20.2235C20.6204 19.1883 19.8117 18.3796 18.7765 18.1022C18.395 18 17.93 18 17 18Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Astronaut01Icon;
